import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ListBaseComponent } from 'app/shared/components/base/list-base/list-base.component';
import { Constants } from 'app/shared/constants/constants';
import { Modals } from 'app/shared/constants/modals';
import { Permissions } from 'app/shared/constants/permissions';
import { Sections } from 'app/shared/constants/sections';
import { CompanyBase } from 'app/shared/models/company-base.model';
import { User } from 'app/shared/models/user.model';
import { SectionService } from 'app/shared/services/section.service';
import { UserService } from 'app/shared/services/user.service';
import { PaginationService } from 'ngx-pagination';
import { format } from 'util';
import { UserFilter } from '../../../shared/filters/user.filter';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
  providers: [PaginationService],
  encapsulation: ViewEncapsulation.None
})
export class UsersListComponent extends ListBaseComponent implements OnInit {

  fieldCollection = [
    {name: 'IsActive', displayName: 'users.isActiveFieldTitle', canSort: true, displayClass: "d-none d-sm-table-cell"},
    {name: 'UserGroupIcon', displayName: 'users.userGroupIconFieldTitle', canSort: false, displayClass: ""},
    {
      name: 'FirstName',
      displayName: 'users.firstNameFieldTitle',
      canSort: true,
      displayClass: "d-none d-sm-table-cell"
    },
    {name: 'LastName', displayName: 'users.lastNameFieldTitle', canSort: true, displayClass: "d-none d-sm-table-cell"},
    {name: 'UserName', displayName: 'users.userNameFieldTitle', canSort: true, displayClass: "d-none d-xl-table-cell"},
    {name: 'Email', displayName: 'users.emailFieldTitle', canSort: true, displayClass: ""},
    {
      name: 'Company.Name',
      displayName: 'users.companyNameFieldTitle',
      canSort: false,
      displayClass: "d-none d-xl-table-cell"
    },
    {
      name: 'TwoFactorEnabled',
      displayName: 'users.twoFactorEnabledFieldTitle',
      canSort: true,
      displayClass: "d-none d-lg-table-cell"
    },
  ];

  private confirmDeactivateUserMessage: string;
  private confirmResetPreSharedKeyMessage: string;
  private userActivatedMessage: string;
  private userDeactivatedMessage: string;
  private userPreSharedKeyResetMessage: string;
  private resetPasswordOfUserMessage: string;

  userFilter: UserFilter;

  get companySelectionListClass(): string {
    if (this.hasSelectCompanyPermission) {
      return "d-none d-xl-block selection-list";
    }

    return "";
  }

  get hasSelectCompanyPermission(): boolean {
    return this.hasPermission(Permissions.Users_SelectCompany);
  }

  get hasResetPasswordPermission(): boolean {
    return this.hasPermission(Permissions.Users_ResetPassword);
  }

  get hasResetPreSharedKeyPermission(): boolean {
    return this.hasPermission(Permissions.Users_ResetPreSharedKey);
  }

  constructor(protected sectionService: SectionService, protected userService: UserService, protected modalService: NgbModal, protected translateService: TranslateService) {
    super(sectionService, Sections.Users, modalService, Modals.UserComponent);
  }

  ngOnInit() {
    this.userFilter = new UserFilter();
    super.initializeView(Constants.Users_List_DefaultSortField, Constants.Users_List_DefaultSortDirectionAscending);
    this.translateService.get(['users.confirmDeactivateUserMessage', 'users.confirmResetPreSharedKeyMessage', 'users.userActivatedMessage',
      'users.userDeactivatedMessage', 'users.userPreSharedKeyResetMessage', 'users.resetPasswordOfUserMessage'])
      .subscribe(translations => {
        this.confirmDeactivateUserMessage = translations['users.confirmDeactivateUserMessage'];
        this.confirmResetPreSharedKeyMessage = translations['users.confirmResetPreSharedKeyMessage'];
        this.userActivatedMessage = translations['users.userActivatedMessage'];
        this.userDeactivatedMessage = translations['users.userDeactivatedMessage'];
        this.userPreSharedKeyResetMessage = translations['users.userPreSharedKeyResetMessage'];
        this.resetPasswordOfUserMessage = translations['users.resetPasswordOfUserMessage'];
      });
  }

  searchFilter(event: any) {
    this.userFilter.Name = event.target.value.toLowerCase();
    this.getCollection(Constants.DefaultPageNumber);
  }

  handleBooleanToggleFilterChanged(newValue: boolean) {
    this.userFilter.ShowActiveAndInActiveItems = newValue;
    this.getCollection();
  }

  handleCompanyChanged(company: CompanyBase) {
    if (company) {
      this.userFilter.CompanyId = company.CompanyId;
    } else {
      this.userFilter.CompanyId = undefined;
    }

    this.getCollection(Constants.DefaultPageNumber);
  }

  activate(user: User) {
    this.userService.activateNow("/users/activate/" + user.UserId, () => this.getCollection(), this.userActivatedMessage)
  }

  deactivate(user: User) {
    if (confirm(format(this.confirmDeactivateUserMessage, user.FirstName, user.LastName))) {
      this.userService.deactivateNow("/users/deactivate/" + user.UserId, () => this.getCollection(), this.userDeactivatedMessage)
    }
  }

  resetPassword(userId: string) {
    this.userService.resetPassword(userId, this.resetPasswordOfUserMessage);
  }

  resetPreSharedKey(user: User) {
    if (confirm(format(this.confirmResetPreSharedKeyMessage, user.FirstName, user.LastName))) {
      this.userService.resetPreSharedKey(user.UserId, () => this.getCollection(), this.userPreSharedKeyResetMessage);
    }
  }

  getCollection(pageNumber: number = 1) {
    if (pageNumber) {
      this.pageConfiguration.PageNumber = pageNumber;
    }

    this.userService.getCollectionPaginated<User>("/users", this.pageConfiguration, this.userFilter, (collection) => {
      this.collection = collection
    });
  }
}
